

// import React, { useState } from "react";
// import "../Users/components/modules/SalesManagment/SalesManagment.css";
// import SalesManagmentall from "../Users/components/modules/SalesManagment/SalesManagmentall.jsx"
// import Salsemannger from "../Users/components/modules/SalesManagment/Salsemannger.jsx";
// // import LeadsOrders from "../Ordermanagment/Caterings/LeadsOrders.js";

// /* ---------- Dummy Section Component ---------- */
// const DummySection = ({ title }) => {
//   return (
//     <div className="dummy-box">
//       <h2>{title}</h2>
//       <p>This is a dummy section for <strong>{title}</strong>.</p>
//       <span>Content will be added later 🚧</span>
//     </div>
//   );
// };

// /* ---------- Main Company Component ---------- */
// const Enquiries = () => {

//   const tabs = [
//     // { id: 8, name: "Leads Orders", component: () => <LeadsOrders title="LeadsOrders" /> },

//     { id: 9, name: "Sales Executive", component: () => <SalesManagmentall title="Newdashbord" /> },
//     { id: 7, name: "Manager", component: () => <Salsemannger title="Sourcing" /> },
  
//   ];

//   const [activeTab, setActiveTab] = useState(tabs[0].id);
//   const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

//   return (
//     <div className="company-container">

//       {/* 🔹 Inline CSS */}
//       <style>{`
//         .company-scroll-container {
//           position: static;
//           background: #fff;
//           overflow-x: auto;
//         }

//         .company-buttons-row {
//           display: flex;
//           flex-wrap: nowrap;
//           gap: 8px;
//         }

//         .company-button {
//           padding: 8px 16px;
//           border: none;
//           background: #f0f0f0;
//           cursor: pointer;
//           border-radius: 6px;
//           white-space: nowrap;
//           font-size: 14px;
//         }

//         .company-button.active {
//           background: #4f46e5;
//           color: #fff;
//         }

//         .dummy-box{
//           padding:40px;
//           text-align:center;
//         }

//         /* Desktop Sticky */
//         @media (min-width: 769px) {
//           .company-scroll-container {
//             position: sticky;
//             top: 0;
//           }
//         }
//       `}</style>

//       {/* Tabs */}
//       <div className="company-scroll-container">
//         <div className="company-buttons-row">
//           {tabs.map(tab => (
//             <button
//               key={tab.id}
//               className={`company-button ${activeTab === tab.id ? "active" : ""}`}
//               onClick={() => setActiveTab(tab.id)}
//             >
//               {tab.name}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Active Section */}
//       <div className="component-display">
//         {ActiveComponent && <ActiveComponent />}
//       </div>

//     </div>
//   );
// };

// export default Enquiries;





import React, { useState } from "react";
import "../vendor/SalesManagment/CompanyTabs.css";
import SalesDashboard from "../vendor/SalesManagment/SalesDashboard";
import SalesEnquiries from "../vendor/SalesManagment/SalesEnquiries";
import SalseQuotation from "../vendor/SalesManagment/SalseQuotation";
// import SalesPipeline from "./SalesPipeline";
// import SalseClients from "./SalseClients";
// import SalesTeam from "./SalesTeam";
// import Salsecommtionsectting from "./Salsecommtionsectting.jsx";
// import SalesReports from "./SalesReports.jsx";
// import PurchaseOrders from "../SalesManagment/PurchaseOrders.jsx";

const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

const Company = () => {
  // Fixed: Correctly mapped tabs with proper components
  const tabs = [
      { id: 2, name: "Dashboard", component: () => <SalesEnquiries title="Dashboard" /> },
    // { id: 7, name: "Sourcing", component: () => <Salsecommtionsectting title="Sourcing" /> },
    { id: 1, name: "Enquiries", component: () => <SalesDashboard title="Dashboard" /> },
  
    { id: 3, name: "Quotation Approval", component: () => <SalseQuotation title="Quotations" /> },
    // { id: 4, name: "Pipeline", component: () => <SalesPipeline title="Pipeline" /> },
    // { id: 5, name: "Clients", component: () => <SalseClients title="Clients" /> },
    // { id: 10, name: "Purchase Orders", component: () => <PurchaseOrders title="Purchase Orders" /> },
    // { id: 6, name: "Projects", component: () => <SalesTeam title="Sales Team" /> },
   
    // { id: 8, name: "Performance", component: () => <SalesReports title="Reports" /> }
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]?.id || 1);

  // Get active component safely
  const activeTabData = tabs.find((tab) => tab.id === activeTab);
  const ActiveComponent = activeTabData?.component;

  return (
    <div className="cm-company-container">
      {/* Tabs */}
      <div className="cm-tabs-wrapper">
        <div className="cm-tabs-scroll">
          <div className="cm-tabs-row">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`cm-tab-btn ${
                  activeTab === tab.id ? "cm-tab-active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
                aria-label={`Switch to ${tab.name} tab`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Active Component */}
      <div className="cm-tab-content">
        <div className="cm-tab-content-inner">
          {ActiveComponent ? (
            <ActiveComponent />
          ) : (
            <div className="dummy-box">
              <h2>No Component Found</h2>
              <p>Please check your tab configuration</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Company;